import { EventrDate, formatDate } from '@eventr/common'
import { ColoursObj, Icon } from '@eventr/common-storybook'
import { useMemo } from 'react'
import {
    DisclosureGroup,
    IDisclosureGroupProps,
} from '../../../common/DisclosureGroup'
import { editItineraryTranslation } from '../../../i18n/translateHelpers'
import { useLanguageContext } from '../../../state/languageState/languageContext'
import { userPrefShowDestTime } from '../../../state/userPrefsState/userPrefsSignels'
import { IGroupedVirtualItem } from './sectionItemsPage'
interface IItemsDisclosureGroupProps
    extends Omit<IDisclosureGroupProps, 'title'> {
    index: number
    group: IGroupedVirtualItem
}
export const ItemsDisclosureGroup = (props: IItemsDisclosureGroupProps) => {
    const { group, index } = props
    const { getLanguageISO639Code } = useLanguageContext()
    const icon = useMemo(() => {
        if (group.date === 'Stands') {
            return 'Stand'
        }
        return 'Calendar'
    }, [group.date])
    return (
        <DisclosureGroup
            childrenHandlePadding
            containerStyle={{
                backgroundColor: ColoursObj.backgrounds.primary,
            }}
            id={index.toString()}
            isOpen={index <= 1}
            count={group.items.length}
            icon={
                <Icon
                    name={icon}
                    iconColour={ColoursObj.backgrounds.primary}
                    bubble
                />
            }
            {...props}
            title={
                group.date !== 'Stands'
                    ? formatDate(
                          new EventrDate(group.date).setTimezoneEnum(
                              new EventrDate().timezoneNumber ?? 0,
                              userPrefShowDestTime.value === 'itinLocal'
                                  ? true
                                  : false
                          ).dateTimeString,
                          userPrefShowDestTime.value,
                          getLanguageISO639Code()
                      )
                    : editItineraryTranslation('Stand', undefined, { count: 2 })
            }
        />
    )
}
